module.exports = __webpack_public_path__ + "static/img/國文師資介紹.c70ba2f9.png";